<template>
  <div v-if="currentEmploye && currentContrat">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Contrat employé'"
          :description="'Aperçu d\'un contrat employé'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17">
                  <td class="col-12 text-center font-weight-bold">
                    Employé concerné
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 d-flex justify-content-between">
                    <div>Nom : {{ currentEmploye.nom }}</div>
                    <div>
                      <router-link
                        :to="{
                          name: 'rh_employe-show',
                          params: { id: currentEmploye.id },
                        }"
                        title="Aperçu"
                      >
                        <i
                          class="fa fa-eye text-custom-primary font-size-17"
                        ></i>
                      </router-link>
                    </div>
                  </td>

                  <td class="col-6 font-weight-bold">
                    Prénom : {{ currentEmploye.prenom }}
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6">
                    Civilité : {{ currentEmploye.civilite.nom }}
                  </td>
                  <td class="col-6 font-weight-bold">
                    Matricule :
                    {{
                      currentEmploye.matricule
                        ? currentEmploye.matricule
                        : '###'
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push(prov).catch(() => {})"
        >
          Liste des contrats
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({
                name: 'rh_employe_contrat-create',
                params: { employeId: currentContrat.id, prov: prov },
              })
              .catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouveau contrat
        </button>
        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'rh_employe_contrat-edit',
                params: {
                  id: currentContrat.id,
                  employeId: currentContrat.id,
                  prov: prov,
                },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
      <div class="col-md-12 col-lg-6">
        <b-button
          variant="success"
          class="btn-icon mr-4"
          @click="statuer(1)"
          v-if="currentContrat.statut === false"
        >
          <span class="btn-icon-label">
            <i class="fas fa-thumbs-up"></i>
          </span>
          Contrat en cours
        </b-button>
        <b-button
          variant="danger"
          class="btn-icon"
          @click="statuer(0)"
          v-if="currentContrat.statut === true"
        >
          <span class="btn-icon-label">
            <i class="fas fa-thumbs-down"></i>
          </span>
          Contrat terminé
        </b-button>
      </div>
    </div>

    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 offset-lg-8 col-lg-4">
          <table class="table table-bordered mb-0 bg-white">
            <tbody>
              <tr>
                <td>
                  <div class="d-flex justify-content-between">
                    <div>
                      <i class="far fa-user text-custom-primary"></i>
                      <span class="font-weight-bold"> Auteur : </span>
                    </div>
                    <div class="text-primary">
                      <span v-if="currentContrat.created_by">
                        {{
                          currentContrat.created_by.prenom
                            ? currentContrat.created_by.prenom +
                              ' ' +
                              currentContrat.created_by.nom
                            : currentContrat.created_by.nom
                        }}
                      </span>
                      <span v-else> ### </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card class="text-black" header-class="bg-silver" no-body>
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-cube mr-0"></i> Entrée
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-calendar text-custom-primary"></i>
                            <span class="font-weight-bold">
                              Date d'entrée dans l'entreprise :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.date_entree }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-calendar text-custom-primary"></i>
                            <span class="font-weight-bold">
                              Date de début du contrat :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.date_debut }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Statut du salarié :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.salarie_statut.nom }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Service : </span>
                          </div>
                          <div>
                            {{ currentContrat.service.nom }} - ({{
                              currentContrat.service.direction.nom
                            }})
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Nature d'emploi :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.emploi_nature.nom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-calendar text-custom-primary"></i>
                            <span class="font-weight-bold">
                              Date d'entrée dans la profession :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.date_entree_profession }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Référence du contrat :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.reference }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-calendar text-custom-primary"></i>
                            <span class="font-weight-bold">
                              Date d'ancienneté :
                            </span>
                          </div>
                          <div>
                            {{
                              currentContrat.date_anciennete
                                ? currentContrat.date_anciennete
                                : '###'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Motif d'entrée :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.motif_entree.nom }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Convention collective :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.convention_collective.nom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Code d'emploi :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.code_emploi }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Situation administrative :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.situation_administrative.nom }}
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Code complémen :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.code_complement }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
      </div>
      <div class="row mt-n3">
        <div class="col-md-12">
          <b-card class="text-black" header-class="bg-silver" no-body>
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-cube mr-0"></i> Emploi
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Type de contrat :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.contrat_type.nom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Spécificité du contrat :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.specificite.nom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Caractéristique du contrat :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.caracteristique }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Intitulé du contrat :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.intitule }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Statut catégoriel CCN :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.ccn_statut_categorie.nom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Emploi multiples :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.emploi_multiple }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-calendar text-custom-primary"></i>
                            <span class="font-weight-bold">
                              Date de fin période d'essai :
                            </span>
                          </div>
                          <div>
                            {{
                              currentContrat.date_fin_periode_essai
                                ? currentContrat.date_fin_periode_essai
                                : '###'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i class="far fa-calendar text-custom-primary"></i>
                            <span class="font-weight-bold">
                              Date première année du contrat :
                            </span>
                          </div>
                          <div>
                            {{
                              currentContrat.date_premier_annee
                                ? currentContrat.date_premier_annee
                                : '###'
                            }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Statut catégoriel IRC :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.irc_statut_categorie.nom }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Employeur multiples ?
                            </span>
                          </div>
                          <div>
                            <b-badge
                              variant="custom-primary"
                              pill
                              v-if="currentContrat.employeur_multiple"
                              class="p-2"
                            >
                              Oui
                            </b-badge>
                            <b-badge
                              variant="custom-primary"
                              pill
                              v-else
                              class="p-2"
                            >
                              Non
                            </b-badge>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Contrat en cours ?
                            </span>
                          </div>
                          <div>
                            <i
                              class="mdi mdi-checkbox-blank-circle mr-1"
                              :class="{
                                'text-success': currentContrat.statut === true,
                                'text-danger': currentContrat.statut === false,
                              }"
                            ></i>
                            {{ getStatutEC(currentContrat.statut) }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card class="text-black" header-class="bg-silver" no-body>
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="fa fa-cube mr-0"></i> Paye
                </h5>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Salaire mensuel :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.salaire | currency }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Heures mensuelles :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.heure_mensuelle }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Heures de référence :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.heure_reference }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Profil : </span>
                          </div>
                          <div>
                            {{ currentContrat.profil.nom }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Forfait en jours :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.forfait_jour }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Expression temps de travail :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.expression_temps_travail.nom }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold">
                              Classement conventionne :
                            </span>
                          </div>
                          <div>
                            {{ currentContrat.classement_conventionnel }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Niveau : </span>
                          </div>
                          <div>
                            {{ currentContrat.niveau }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Indice : </span>
                          </div>
                          <div>
                            {{ currentContrat.indice }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Position </span>
                          </div>
                          <div>
                            {{ currentContrat.position }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex justify-content-between">
                          <div>
                            <i
                              class="fa fa-info-circle text-custom-primary"
                            ></i>
                            <span class="font-weight-bold"> Echelon </span>
                          </div>
                          <div>
                            {{ currentContrat.echelon }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL_C from '@/http/rh/contrat';
import URL_E from '@/http/rh/employe';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      currentContrat: null,
      prov: this.$route.params.prov,
      title: 'Gestion des contrats - Aperçu',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('employe', ['currentEmploye']),
  },
  methods: {
    statuer(statut) {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL_C.STATUER + '/' + this.currentContrat.id + '/' + statut)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    ...mapActions('employe', ['setCurrentEmploye']),
    init() {
      this.setCurrentEmploye(null);

      window.axios
        .all([
          window.axios.get(URL_E.EMPLOYE + '/' + this.$route.params.employeId),
          window.axios.get(URL_C.CONTRAT + '/' + this.$route.params.id),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.setCurrentEmploye(resp1.data.employe);
            this.currentContrat = resp2.data.contrat;
          })
        )
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
